import Const from 'constants';
import {getPropValues} from 'helpers/array-helper';
import {getValue} from 'helpers/common-helper';
import {getLpService} from 'services/sports/factory';
import {generateRandomKey} from 'helpers/hash';
import {secondaryStackCombinationsMap} from 'components/organisms/player-position-stacking/helpers';

function isStackItemGroupConstraintDoable(item) {
    if (Const.STACKS_TYPE_AT_LEAST === item.condition && 0 === Number(item.limit)) {
        return false;
    }
    if (Const.STACKS_TYPE_AT_MOST === item.condition && item.players.length <= item.limit) {
        return false;
    }
    return true;
}

let Stack = {
    setNonControlledStack(stack) {
        return {
            type: Const.SET_NON_CONTROLLED_STACK,
            data: stack,
        };
    },
    removeNonControlledStack(key) {
        return {
            type: Const.REMOVE_NON_CONTROLLED_STACK,
            data: key,
        };
    },
    useNHLNonControlledStack(data) {
        return {
            type: Const.NHL_NON_CONTROLLED_STACK_IS_USED,
            data: data,
        };
    },
    setNHLNonControlledStackMode(data) {
        return {
            type: Const.NHL_NON_CONTROLLED_STACK_SET_STACK_MODE,
            data: data,
        };
    },
    addNHLNonControlledStackItem(groupNumber) {
        return {
            type: Const.NHL_NON_CONTROLLED_STACK_ADD_ITEM,
            groupNumber: groupNumber,
        };
    },
    removeNHLNonControlledStackItem(groupNumber, itemNumber) {
        return {
            type: Const.NHL_NON_CONTROLLED_STACK_REMOVE_ITEM,
            groupNumber: groupNumber,
            itemNumber: itemNumber,
        };
    },
    setNHLNonControlledStackTeam(groupNumber, itemNumber, team) {
        return {
            type: Const.NHL_NON_CONTROLLED_STACK_SET_TEAM_TO_ITEM,
            groupNumber: groupNumber,
            itemNumber: itemNumber,
            team: team,
        };
    },
    setNHLNonControlledStackPayersInGroup(groupNumber, value) {
        return {
            type: Const.NHL_NON_CONTROLLED_STACK_SET_PLAYERS_IN_GROUP,
            groupNumber: groupNumber,
            value: value,
        };
    },
    setNHLNonControlledStackExposure(groupNumber, itemNumber, exposure) {
        return {
            type: Const.NHL_NON_CONTROLLED_STACK_SET_EXPOSURE_TO_ITEM,
            groupNumber: groupNumber,
            itemNumber: itemNumber,
            exposure: exposure,
        };
    },
    setNHLNonControlledStackLineGroups(groupNumber, itemNumber, lineGroups) {
        return {
            type: Const.NHL_NON_CONTROLLED_STACK_SET_LINE_GROUP_TO_ITEM,
            groupNumber,
            itemNumber,
            lineGroups,
        };
    },
    setNHLNonControlledStackPPLines(groupNumber, itemNumber, ppLines) {
        return {
            type: Const.NHL_NON_CONTROLLED_STACK_SET_PP_LINE_TO_ITEM,
            groupNumber,
            itemNumber,
            ppLines,
        };
    },
    useNHLNameStack(data) {
        return {
            type: Const.NHL_NAME_STACK_IS_USED,
            data: data,
        };
    },
    setNHLNameDoubleStackMode(data) {
        return {
            type: Const.NHL_NAME_STACK_IS_DOUBLE_STACK_MODE,
            data: data,
        };
    },
    setNHLNameStackPayersInGroup(groupNumber, value) {
        return {
            type: Const.NHL_NAME_STACK_SET_PLAYERS_IN_GROUP,
            groupNumber: groupNumber,
            value: value,
        };
    },
    addNHLNameStackItem(groupNumber) {
        return {
            type: Const.NHL_NAME_STACK_ADD_ITEM,
            groupNumber: groupNumber,
        };
    },
    removeNHLNameStackItem(groupNumber, itemNumber) {
        return {
            type: Const.NHL_NAME_STACK_REMOVE_ITEM,
            groupNumber: groupNumber,
            itemNumber: itemNumber,
        };
    },
    setNHLNameStackTeam(groupNumber, itemNumber, team) {
        return {
            type: Const.NHL_NAME_STACK_SET_TEAM_TO_ITEM,
            groupNumber: groupNumber,
            itemNumber: itemNumber,
            team: team,
        };
    },
    setNHLNameStackExposure(groupNumber, itemNumber, exposure) {
        return {
            type: Const.NHL_NAME_STACK_SET_EXPOSURE_TO_ITEM,
            groupNumber: groupNumber,
            itemNumber: itemNumber,
            exposure: exposure,
        };
    },
    setNHLNameStackPlayers(groupNumber, itemNumber, players) {
        return {
            type: Const.NHL_NAME_STACK_SET_PLAYER_TO_ITEM,
            groupNumber: groupNumber,
            itemNumber: itemNumber,
            players: players,
        };
    },
    updateNhlStackPlayers() {
        return (dispatch, getState) => {
            const state = getState();
            let groups = state.stacks.nhlName.groups;
            Object.keys(groups).map(function (groupNumber) {
                let group = groups[groupNumber];
                for (let itemNumber in group.items) {
                    let itemKey = group.items[itemNumber];
                    let playersPushToState = [];
                    for (let playerKey in itemKey.players) {
                        let player = itemKey.players[playerKey];
                        playersPushToState.push(state.playersData.players.getPlayer(player.playerId));
                    }

                    dispatch({
                        type: Const.NHL_NAME_STACK_SET_PLAYER_TO_ITEM,
                        groupNumber: groupNumber,
                        itemNumber: itemNumber,
                        players: playersPushToState,
                    });
                }
            });
        };
    },
    createGroupsOfStacks() {
        return (dispatch, getState) => {
            const {sportConfig} = getState();

            dispatch({
                type: Const.RESET_GROUPS_OF_STACKS,
            });

            getLpService(sportConfig, {store: null}).exec('createGroupsOfStacks', {dispatch});
        };
    },
    createGroupsOfPositionStacks(playersGroupedByTeam) {
        return (dispatch, getState) => {
            const {
                sportConfig,
                playerNameStacking,
                playerPositionStacking,
                playersData: {players, filters},
            } = getState();

            function getExcludables(stackItem) {
                let excludedTeams = [],
                    excludedPlayerIds = [];

                if ('exclusionSettings' in stackItem) {
                    const {exclusionSettings} = stackItem;

                    if (exclusionSettings.exclusionType === Const.STACK_WITH_TEAM_EXCLUSION) {
                        excludedTeams = exclusionSettings.excludedTeams;
                    } else if (exclusionSettings.exclusionType === Const.STACK_WITH_PLAYER_EXCLUSION) {
                        excludedPlayerIds = exclusionSettings.excludedPlayers;
                    }
                }

                return {excludedTeams, excludedPlayerIds};
            }

            function filterPlayerIdsByExcludables(playerIds, teamName, excludables) {
                const {excludedTeams, excludedPlayerIds} = excludables;

                return inArray(teamName, excludedTeams)
                    ? []
                    : playerIds.filter((playerId) => !inArray(playerId, excludedPlayerIds));
            }

            function getPlayerIdsFromTeamByPositions(team, positions) {
                const playerIds = [];

                Object.keys(team)
                    .filter((pos) => inArray(pos, positions))
                    .map((pos) => {
                        team[pos].map((player) => playerIds.push(player.playerId));
                    });

                return arrayUnique(playerIds);
            }

            function getPlayerIdsOnSelectedPositions(stackItem, team) {
                if (stackItem.isSameTeam) {
                    return getPlayerIdsFromTeamByPositions(team.positions, stackItem.selectedPositions);
                } else if (!isEmpty(playersGroupedByTeam[team.opponent])) {
                    return getPlayerIdsFromTeamByPositions(
                        playersGroupedByTeam[team.opponent].positions,
                        stackItem.selectedPositions,
                    );
                }

                return [];
            }

            function createStackItemGroups(stackItem, keyPlayers, stackablePlayers) {
                const groups = [];
                keyPlayers.map((playerId) => {
                    const group = {
                        stackItemId: stackItem.id,
                        players: arrayRemoveValues(stackablePlayers, playerId),
                        keys: [playerId],
                        condition: stackItem.type,
                        limit: stackItem.numberPlayers,
                        stackBoostPercent: stackItem.stackBoostPercent ?? 0,
                        keyPlayerLineupPosition: stackItem.keyPlayerLineupPosition ?? '',
                        isPrimaryStack: stackItem.isPrimaryStack ?? true,
                        isStackItemForcible: stackItem.isStackItemForcible ?? false,
                        isSameTeam: stackItem.isSameTeam,
                    };

                    isStackItemGroupConstraintDoable(group) && groups.push(group);
                });

                return groups;
            }

            function createStackItemsOfSecondaryStackCombinations(sportConfig, playerPositionStacking) {
                const canCombinationsBeUsed =
                    sportConfig.isSportNfl() &&
                    sportConfig.isGameTypeClassic() &&
                    playerPositionStacking.isSecondaryStackUsed();

                if (!canCombinationsBeUsed) {
                    return [];
                }

                const combinations = playerPositionStacking.getSecondaryStackCombinations();

                return Object.keys(Const.SECONDARY_STACK_COMBINATION_TYPES)
                    .filter((type) => combinations[type])
                    .map((type) =>
                        cp({
                            ...secondaryStackCombinationsMap[type],
                            id: generateRandomKey(),
                            isStackItemForcible: playerPositionStacking.isSecondaryStackForced(),
                        }),
                    );
            }

            let stackItems = [];
            if (playerPositionStacking.isEnabled()) {
                stackItems = [
                    ...playerPositionStacking.getItems(),
                    ...createStackItemsOfSecondaryStackCombinations(sportConfig, playerPositionStacking),
                ];
            }
            if (playerNameStacking.isEnabled()) {
                stackItems = [...stackItems, ...playerNameStacking.getItems()];
            }

            let stackItemGroups = [];
            Object.values(stackItems).map((stackItem) => {
                const excludables = getExcludables(stackItem);

                /** In order to avoid mistake from glpk lib just skip stack with such configuration. */
                if (Const.STACKS_TYPE_AT_LEAST === stackItem.type && 0 >= stackItem.numberPlayers) {
                    return;
                }

                if (stackItem.stackWith === Const.STACK_WITH_PLAYER) {
                    const keyPlayer = players.getPlayer(stackItem.keyPlayers[0] ?? '');

                    if (keyPlayer === null) {
                        return;
                    }

                    const stackablePlayers = [];
                    stackItem.selectedPlayers.map((playerId) => {
                        const player = players.getPlayer(playerId);
                        const isPlayerStackable =
                            player !== null ||
                            !player.isExcludedAnywhere() ||
                            inArray(player.team, filters.games) ||
                            player.exposureMax > 0;

                        isPlayerStackable && stackablePlayers.push(playerId);
                    });

                    if (
                        !isEmpty(stackablePlayers) &&
                        !keyPlayer.isExcludedAnywhere() &&
                        inArray(keyPlayer.team, filters.games)
                    ) {
                        stackItemGroups = [
                            ...stackItemGroups,
                            ...createStackItemGroups(stackItem, stackItem.keyPlayers, stackablePlayers),
                        ];
                    }
                } else {
                    if (!isEmpty(stackItem.keyPlayers)) {
                        const player = players.getPlayer(stackItem.keyPlayers[0] ?? '');

                        if (player === null) {
                            return;
                        }

                        const team = playersGroupedByTeam[player.team];

                        let stackablePlayers = getPlayerIdsOnSelectedPositions(stackItem, team);
                        stackablePlayers = filterPlayerIdsByExcludables(stackablePlayers, player.team, excludables);

                        stackItemGroups = [
                            ...stackItemGroups,
                            ...createStackItemGroups(stackItem, stackItem.keyPlayers, stackablePlayers),
                        ];
                    } else {
                        Object.keys(playersGroupedByTeam).map((teamName) => {
                            const team = playersGroupedByTeam[teamName];

                            const keyPositions = stackItem.keyPositions.filter(
                                (keyPosition) => !isEmpty(team.positions[keyPosition] ?? []),
                            );

                            let keyPlayers = getPlayerIdsFromTeamByPositions(team.positions, keyPositions);
                            keyPlayers = filterPlayerIdsByExcludables(keyPlayers, teamName, excludables);

                            let stackablePlayers = getPlayerIdsOnSelectedPositions(stackItem, team);
                            stackablePlayers = filterPlayerIdsByExcludables(stackablePlayers, teamName, excludables);

                            stackItemGroups = [
                                ...stackItemGroups,
                                ...createStackItemGroups(stackItem, keyPlayers, stackablePlayers),
                            ];
                        });
                    }
                }
            });

            dispatch({
                type: Const.SET_GROUPS_OF_STACKS,
                data: stackItemGroups,
            });
        };
    },
    createGroupsOfDominatorStacks(playersGroupedByDominator) {
        return (dispatch, getState) => {
            const groups = [];
            const dominators = getValue(playersGroupedByDominator, 1, []);
            const {dominatorStacking: stacking} = getState();

            if (stacking.isEnabled() && stacking.hasItems()) {
                const stacks = stacking.getItems();
                stacks.map((stack) => {
                    /** If type of stack is "AT_LEAST" and number of players is 0, move to next iteration. */
                    if (stack.type === Const.STACKS_TYPE_AT_LEAST) {
                        if (Number(stack.numberPlayers) === 0) {
                            return false;
                        } else if (stack.numberPlayers > dominators.length) {
                            throw new Error(Const.ZERO_GENERATED_LINEUPS_MESSAGE);
                        }
                    }

                    /**
                     * If type of stack is "AT_MOST" and pool of dominators is less or equal number of players,
                     * move to next iteration.
                     */
                    if (stack.type === Const.STACKS_TYPE_AT_MOST) {
                        if (stack.numberPlayers >= dominators.length) {
                            return false;
                        }
                    }

                    /**
                     * If type of stack is "EXACTLY"
                     * and pool of dominators has 0 players and number of players is 0, move to next iteration.
                     */
                    if (stack.type === Const.STACKS_TYPE_EXACTLY) {
                        if (Number(stack.numberPlayers) === 0 && !dominators.length) {
                            return false;
                        } else if (stack.numberPlayers > dominators.length) {
                            throw new Error(Const.ZERO_GENERATED_LINEUPS_MESSAGE);
                        }
                    }

                    /** DY - dominator yes; DN - dominator no; */
                    let DYPlayerIds = [],
                        DNPlayerIds = [];
                    Object.keys(playersGroupedByDominator).map((isDominator) => {
                        const group = playersGroupedByDominator[isDominator];

                        if (Boolean(Number(isDominator))) {
                            DYPlayerIds = getPropValues(group, 'playerId');
                        } else {
                            DNPlayerIds = getPropValues(group, 'playerId');
                        }
                    });

                    const group = {
                        stackItemId: stack.id,
                        players: DYPlayerIds,
                        keys: DNPlayerIds,
                        condition: stack.type,
                        limit: stack.numberPlayers,
                    };

                    isStackItemGroupConstraintDoable(group) && groups.push(group);
                });
            }

            dispatch({
                type: Const.SET_GROUPS_OF_STACKS,
                data: groups,
            });
        };
    },
    createGroupsOfTeamStacks(playersGroupedByTeam) {
        return (dispatch, getState) => {
            const createGroup = (teamPlayerIds, condition, playersLimit) => {
                if (playersLimit > teamPlayerIds.length) {
                    throw new Error(Const.ZERO_GENERATED_LINEUPS_MESSAGE);
                }

                return {
                    stackItemId: generateRandomKey(),
                    players: teamPlayerIds,
                    condition: condition,
                    limit: playersLimit,
                };
            };

            const groups = [];

            const {
                teamNameStacking: stacking,
                playersData: {
                    filters: {games: activeTeams},
                },
                sportConfig,
            } = getState();

            const teamsOptions = stacking.getTeamOptions();
            if (stacking.isEnabled() && !isEmpty(teamsOptions)) {
                Object.keys(teamsOptions).map((teamName) => {
                    if (!activeTeams.includes(teamName)) {
                        return false;
                    }

                    if (!playersGroupedByTeam.hasOwnProperty(teamName)) {
                        return false;
                    }

                    const teamPlayerIds = getPropValues(playersGroupedByTeam[teamName], 'playerId');
                    const teamOptions = teamsOptions[teamName];

                    if (!teamOptions.enabled) {
                        return false;
                    }

                    const minPlayers = teamOptions.minPlayers;
                    const maxPlayers = teamOptions.maxPlayers;
                    const teamPlayersCount = teamPlayerIds.length;

                    if (minPlayers === maxPlayers) {
                        /**
                         * If type of stack is "EXACTLY"
                         * and pool of players in team has 0 players, move to next iteration.
                         */
                        if (teamPlayersCount === 0) {
                            return false;
                        }

                        groups.push(createGroup(teamPlayerIds, Const.STACKS_TYPE_EXACTLY, minPlayers));
                    } else {
                        if (minPlayers > 0) {
                            groups.push(createGroup(teamPlayerIds, Const.STACKS_TYPE_AT_LEAST, minPlayers));
                        }

                        const maxSingleTeamPlayers = sportConfig.getConfigProp('maxSingleTeamPlayers');

                        if (maxPlayers < maxSingleTeamPlayers && maxPlayers < teamPlayersCount) {
                            groups.push(createGroup(teamPlayerIds, Const.STACKS_TYPE_AT_MOST, maxPlayers));
                        }
                    }
                });
            }

            dispatch({
                type: Const.SET_TEAM_NAME_STACKING_GROUPS,
                data: groups,
            });
        };
    },
    switchPlayerGroupings(isOn) {
        return {
            type: Const.PLAYER_GROUPINGS_SWITCH_IS_ON,
            isOn,
        };
    },
};

export default Stack;
